module.exports = __webpack_public_path__ + "img/Danny Holland.397662f8.jpg";